module.exports = __webpack_public_path__ + "img/icons8-phonelink-ring.e8c28cef.svg";